module.exports = __webpack_public_path__ + "img/honour8.b7a60100.png";